// Campus photo for /colleges/university-of-san-diego: CC BY-SA 4.0, by Transfeo, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_San_Diego.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-san-diego/; credited under the photo.
const photo = {
    "slug": "university-of-san-diego",
    "alt": "The Immaculata church tower and Spanish Renaissance style buildings above the fountain and gardens of the University of San Diego campus in San Diego, California",
    "src": "/colleges/university-of-san-diego/campus-1600.webp",
    "srcSmall": "/colleges/university-of-san-diego/campus-800.webp",
    "srcMid": "/colleges/university-of-san-diego/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-san-diego/og.jpg",
    "title": "University of San Diego",
    "author": "Transfeo",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_San_Diego.jpg",
    "read": "2026-10-01"
};

export default photo;
